import Form, { FormProps } from "@/shared/form/form";
import { FieldsType } from "../model/types";
import Input from "@/shared/form/input";
import { useTranslations } from "use-intl";
import { PersonSelect } from "@/modules/common/entities/person/select";
import { SubmitButton, SubmitWrapper } from "@/shared/form/button";

export function CompanyDocumentConfirmationForm(props: FormProps<FieldsType>) {
  const t = useTranslations("Common");

  return (
    <Form {...props}>
      <Form.Item<FieldsType> name="documentId" hidden>
        <Input />
      </Form.Item>

      <Form.Item<FieldsType>
        name="personIds"
        label={t("Person")}
        rules={[{ required: true }]}
      >
        <PersonSelect mode="multiple" />
      </Form.Item>

      <SubmitWrapper>
        <SubmitButton />
      </SubmitWrapper>
    </Form>
  );
}
